<!-- Modal -->
<template>
    <div class="modal fade" id="createPermissionModal" ref="createPermissionModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="savePermission">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Permission save</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-3">
								<label for="name">Name</label>
								<input type="text" v-model="permission.name" placeholder="Enter name" class="form-control" required />
							</div>

                            <div class="mb-3">
                                <label for="permission-description" class="form-label">Description</label>
                                <textarea v-model="permission.description" class="form-control" id="permission-description" rows="3"></textarea>
                            </div>

                            <div class="form-control my-4 p-4">
                                <div class="row">
                                    <div class="mb-2">Groups</div>
                                    <div v-for="group in groups" class="form-check form-check-inline col-md-4 me-0 mb-1" :key="group.id">
                                        <input class="form-check-input" type="radio" v-model="permission.group_id" :id="`flexSwitchCheckGroups${group.id}`" :value="group.id">
                                        <label class="form-check-label" :for="`flexSwitchCheckGroups${group.id}`">{{ group.name }}</label>
                                    </div>
                                </div>
                            </div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">Save</button>
						</div>
					</form>
				</div>
			</div>
		</div>
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'

export default {
    name: "CreatePermissionModal",
    components: {
    },
    emits: ["permissionSaved", "createPermissionModalClosed"],
    data: () => ({
        modal: null,
        inProgress: false,
        groups: [],
        permission: {
            name: '',
            group_id: 1,
            description: ''
        },
    }),
    mounted() {
        this.modal = new Modal(this.$refs.createPermissionModal);

        
        let createPermissionModal = document.getElementById("createPermissionModal");
        
        let self = this;
        
        createPermissionModal.addEventListener("hidden.bs.modal", function () {
            
            self.$emit("createPermissionModalClosed");
            
            self.permission = {
                name: ''
			};
        });
    },
    watch: {
        permissionForChildComponent (permission) {
            this.permission = permission;
            this.permissionGroups = (this.permission.groups && this.permission.groups.length) ? this.permission.groups.map(group => group.name) : [];
        },
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
                this.permission = this.permissionForChildComponent;
                this.setGroups();
            }
        },
		async savePermission () {

            this.permission.groups = this.permissionGroups;

            try {
                
                if (this.update) {
                    await juniperApi.put(`/permissions/${this.permission.id}`, this.permission);
                } else {
                    await juniperApi.post(`/permissions`, this.permission);
                }

                this.$swal.fire({
                    icon: 'success',
                    title: 'Permission saved successfully!',
                    timer: 4000,
                })

                this.modal.hide();
                this.$emit("permissionSaved");

            } catch (error) {
                let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                if (error.response.data.message) {
                    message += error.response.data.message;
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 6000,
                })
            }
		},
        async setGroups() {
            const res = await juniperApi.get('/permission-groups');
            this.groups = res.data;
        }
    },
    computed: {
        
    },
    props: {
        update: Boolean,
        permissionForChildComponent: Object
    },
};
</script>
